import { useDataChange } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onRowClick() {
    change(next => {
      next.question_id = 'new'
      next.question_type_id = null
      next.question_template = {}
    })
    setFlowTo(normalizePath(props.viewPath, '../Editor/Content'))
  }
}
